import React from 'react'
import {logRender} from "../../utils/logging";
import { withTranslation } from 'react-i18next'
import {connect} from "react-redux";
import {deepEqualObjs2, isDef} from "../../utils/objtools";
import Teaser from "../teaser/Teaser";
import AnimDelay from "../ui/AnimDelay/AnimDelay";
import {mapResourceFromIds} from "../resource/resource_selectors";

class ApiRelatedProducts extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !deepEqualObjs2(this.props.redux, nextProps.redux)
      || this.props.tReady !== nextProps.tReady
    )
  }

  componentDidMount() {
    this.postRender()
  }

  componentDidUpdate() {
    this.postRender()
  }

  postRender() {
    if (this.props.redux.api_related_products.need_request) {
      this.props.requestResource(this.props.redux.api_related_products.external_resource_infos)
    }
  }

  render() {
    logRender(this)
    if (!this.props.tReady)
      return null

    var apiRelatedProducts = []
    if (isDef(this.props.redux, 'api_related_products.itemsResourceCodes')){
      for (let item of this.props.redux.api_related_products.itemsResourceCodes){
        apiRelatedProducts.push(<Teaser key={item} item_type="product" resource_code={item}/>)
      }
    }

    if (apiRelatedProducts.length)
      apiRelatedProducts = (
        <AnimDelay animateAppearance={true} showDelay={100}>
          <h2>{this.props.t('api:related_products')}</h2>
          <div className="grid g1_432col">
            {apiRelatedProducts}
          </div>
        </AnimDelay>
      )


    return (
      <div className={this.getItemClasses().join(' ')} >
        {apiRelatedProducts}
      </div>
    )
  }

  getItemClasses() {
    var classes = [
      'api_related_products'
    ]
    return classes;
  }
}


const mapStateToProps = (state, ownProps) => {
  var redux = {
    lang_code: state.lang.lang_code,
    api_related_products: mapResourceFromIds(state, 'api_related_products', ownProps.api_ids)
  }

  return {
    redux
  }
}

const mapDispatchToProps = dispatch => ({
  requestResource: (external_resource_infos) => dispatch({type:'RESOURCE_LOAD_REQUEST', external_resource_infos})
})

ApiRelatedProducts = withTranslation(
  ['api']
)(ApiRelatedProducts)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApiRelatedProducts)

